export default __webpack_public_path__ + "static/media/01c_folded.43711cae.png";